/* Aktywna kropka galerii zdjec na kafelku listingu kolekcji (swipe na mobile).

   Dlaczego 'scroll' + requestAnimationFrame, a nie IntersectionObserver:
   obserwator wymagalby root = tor, czyli osobnego obserwatora na kazdy kafelek
   (48 produktow na stronie). Przewija sie zawsze tylko JEDEN tor, wiec pasywny
   nasluch jest tanszy i prostszy. Indeks liczymy z scrollLeft/clientWidth,
   bo kazdy slajd ma szerokosc 100% toru (flex:0 0 100%).

   Filtry kolekcji podmieniaja innerHTML #ProductGridContainer (facets.js:120,
   facets-CUSTOM.js:120) i NIE emituja zadnego zdarzenia -> nowe kafelki nie
   mialyby nasluchow. Dlatego MutationObserver, a nie hook w facets.js: filtry maja
   dwie blizniacze implementacje i dopisywanie w obu to dwa miejsca do utrzymania. */
(function () {
  function activate(dots, index) {
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  function initGallery(track) {
    if (track.dataset.galleryReady === '1') return;   // MutationObserver strzela wielokrotnie

    var dotsWrapper = track.parentNode.querySelector('.product-card-gallery__dots');
    if (!dotsWrapper) return;                          // 1 zdjecie = brak kropek = nic do roboty

    var dots = dotsWrapper.querySelectorAll('span');
    if (dots.length < 2) return;

    var pending = false;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var width = track.clientWidth;
        if (!width) return;
        var index = Math.round(track.scrollLeft / width);
        if (index < 0) index = 0;
        if (index > dots.length - 1) index = dots.length - 1;
        activate(dots, index);
      });
    }, { passive: true });   // bez passive przegladarka czeka na ewentualny preventDefault -> szarpanie

    track.dataset.galleryReady = '1';
  }

  function initProductCardGalleries(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('.product-card-gallery');
    for (var i = 0; i < tracks.length; i++) initGallery(tracks[i]);
  }

  window.initProductCardGalleries = initProductCardGalleries;

  function boot() {
    initProductCardGalleries();

    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    new MutationObserver(function () {
      initProductCardGalleries(container);
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
